const getCreatedTextures = (instance) => {
  const textureNames = [];

  const keys = Object.getOwnPropertyNames(instance);

  for (let i = 0; i < keys.length; i++) {
    if (keys[i].toLowerCase().indexOf('texture') >= 0) {
      textureNames.push(keys[i]);
    }
  }

  return textureNames;
};

export default getCreatedTextures;
